<template>
    <span class="nav-link" @click.prevent="click">
        <svg xmlns="http://www.w3.org/2000/svg" width="35px" height="35px" viewBox="0 0 64 64" enable-background="new 0 0 64 64" xml:space="preserve">
            <path d="M49.028,17.195c-2.146-2.183-5.003-3.384-8.044-3.384c-3.039,0-5.898,1.205-8.051,3.393l-0.921,0.937 l-0.938-0.954c-2.158-2.193-5.021-3.401-8.06-3.401c-3.035,0-5.888,1.202-8.035,3.384c-2.154,2.19-3.336,5.096-3.327,8.181 c0,3.078,1.188,5.98,3.344,8.173l16.002,16.271c0.263,0.269,0.623,0.422,0.988,0.422c0.37,0,0.729-0.15,0.987-0.412l16.037-16.246 c2.15-2.188,3.336-5.092,3.336-8.18C52.355,22.286,51.178,19.38,49.028,17.195z M23.015,16.633c2.295,0,4.453,0.909,6.076,2.559 l1.926,1.958c0.531,0.541,1.452,0.541,1.983,0l1.909-1.941c1.624-1.65,3.778-2.559,6.067-2.559c2.281,0,4.434,0.906,6.06,2.55 c1.618,1.646,2.511,3.839,2.511,6.177c0.008,2.328-0.883,4.521-2.51,6.174L31.988,46.793L16.972,31.525 c-1.624-1.652-2.519-3.845-2.519-6.176c0-2.339,0.891-4.529,2.51-6.167C18.581,17.539,20.73,16.633,23.015,16.633z"/>
        </svg>
        <span class="nav-link-badge">{{ favoriteItemsCount() }}</span>
        <span class="nav-link-text">Избранное</span>
    </span>
</template>

<script>
    import { mapState, mapGetters, mapMutations } from 'vuex';

    export default {
        name: "CustomerFavorites",
        computed: {
            ...mapState('auth', [
                'logged',
            ]),
        },
        methods: {
            ...mapMutations('auth', {
                showAuthModal: 'showModal'
            }),
            ...mapGetters('product', [
                'favoriteItemsCount',
            ]),
            click () {
                if (this.logged) {
                    location.href = '/account/favorites';
                } else {
                    this.showAuthModal();
                }
            }
        },
    }
</script>
